export default __webpack_public_path__ + "static/media/tip15.b5be220f.png";